import { useMemo } from 'react'
import { deviceZone, zoneChoices } from '../utils/timeZones'

/** A choice of time zone ("Africa/Lagos (GMT+1)"), for the company's clock. */
export default function TimeZoneSelect({ value, onChange, placeholder = 'Choose…', ...rest }) {
  const zones = useMemo(() => zoneChoices(value, deviceZone()), [value])
  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} {...rest}>
      {!value && <option value="">{placeholder}</option>}
      {zones.map(([z, label]) => <option key={z} value={z}>{label}</option>)}
    </select>
  )
}
